import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SalesforceResponse, GlobalPosition, PendingHiring } from '@api/models';
import { environment } from '@environment/environment';
import { map, tap, finalize, catchError } from 'rxjs/operators';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ErrorHandlerService } from '../errors/error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalPositionService {
  private globalPositionSource = new BehaviorSubject<GlobalPosition>(null);
  private pendingRequest = false;
  private subs = new Subscription();

  get globalPosition$() {
    return this.globalPositionSource.pipe(
      tap((globalPosition) => {
        if (!globalPosition) {
          this.fetchGlobalPosition();
        }
      })
    );
  }

  constructor(private http: HttpClient, private errorHandlerService: ErrorHandlerService) {}

  fetchGlobalPosition() {
    if (this.pendingRequest) {
      return;
    }

    this.pendingRequest = true;

    // clear current data when is loading
    if (this.globalPositionSource.getValue()) {
      this.globalPositionSource.next(null);
    }

    this.subs = this.getGlobalPosition()
      .pipe(
        finalize(() => {
          this.pendingRequest = false;
        })
      )
      .subscribe((globalPosition) => {
        const Acuerdo = globalPosition.Accounts
          .filter(acc => acc.Name === "PLAZO FIJO")
          .map(({ Acuerdo }) => Acuerdo)

        localStorage.setItem("Acuerdo", Acuerdo[0])
        this.globalPositionSource.next(globalPosition);
      });

  }

  destroy() {
    this.subs.unsubscribe();
  }

  pendingHirings() {
    return this.http.get<PendingHiring>(
      `${environment.apiBasePath}${environment.endpoints.pendingHirings}`
    );
  }

  private getGlobalPosition() {
    return this.http
      .get<SalesforceResponse<GlobalPosition>>(
        `${environment.apiBasePath}${environment.endpoints.globalposition}`
      )
      .pipe(
        map((response) => response.data?.[0]),
        catchError((e) => this.errorHandlerService.redirectErrorPage(e))
      );
  }
}
